import palette from './palette';
import themeTypography from '../themeTypography';


// ==============================|| TYPOGRAPHY ||============================== //


const typography = {


  ...themeTypography,

  underLine: {
    paddingBottom: 1,
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      width: 32,
      height: 2,
      position: 'absolute',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: palette.color.secondaryGreen1
    }
  },
  leftLine: { 
    paddingBottom: 1,
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      width: 32,
      height: 2,
      position: 'absolute',
      bottom: 0,
      left: 0,
      // palette.secondary.main
      backgroundColor: palette.color.secondaryGreen1
    }
  },
  fullLine: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      width: '100%',
      height: 2,
      position: 'absolute',
      bottom: 0,
      left: 0,
      backgroundColor: palette.color.secondaryGreen1
    }
  },


  verticalLine: {
    position: 'relative',
    paddingLeft: 1,
    '&:before': {
      content: '""',
      width: 4,
      height: 16,
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: 0,
      marginTop: -1,
      backgroundColor: theme => theme.palette.primary.main
    }
  },

  hoverPrimaryUnderline1px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      margin: '0 auto',
      width: '0%',
      height: '1px',
      background: palette.color.primaryBlue3,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },
  hoverPrimaryLeftline1px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      width: '0%',
      height: '1px',
      backgroundColor: palette.color.primaryBlue3,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },

  hoverPrimaryUnderline2px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      margin: '0 auto',
      width: '0%',
      height: '2px',
      background: palette.color.primaryBlue3,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },
  hoverPrimaryLeftline2px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      width: '0%',
      height: '2px',
      backgroundColor: palette.color.primaryBlue3,
      transition: 'all 0.5s',
      zIndex: 1,
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },

  hoverSecondaryUnderline2px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      margin: '0 auto',
      width: '0%',
      height: '2px',
      background: palette.color.secondaryGreen1,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },

  hoverUnderLine4px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 0,
      right: 0,
      left: 0,
      margin: '0 auto',
      width: '0%',
      height: '4px',
      background: palette.color.secondaryGreen1,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },
  hoverLeftLine4px: {
    position: 'relative',
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: -1,
      right: 0,
      left: 0,
      width: '0%',
      height: '4px',
      backgroundColor: palette.color.secondaryGreen1,
      transition: 'all 0.5s',
    },
    '&:hover': {
      '&:after': {
        width: '100%',
      },
    }
  },

  scrollbar: {
    /* custom scrollbar */
    '&::-webkit-scrollbar': {
      width: 20,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d6dee1',
      borderRadius: 20,
      border: '6px solid transparent',
      backgroundClip: 'content-box',
      '&:hover': {
        backgroundColor: '#a8bbbf'
      }
    },
  }
};

export default typography;
